import { HistoryItemProps } from "@/components/history/types";
import { FC } from "react";
import { format } from "date-fns";
import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from "@/constants";
import { Row } from "@/components/row";

import { AvatarLoadManager } from "@/components/avatar-load-manager";
import styles from "./styles.scss";
import { Profile } from "@/assets/icons";

export const HistoryItem: FC<HistoryItemProps> = ({ historyItem, order }) => {
  return (
    <>
      {order > 0 && (
        <div className={styles.arrowContainer}>
          <div className={styles.arrowPeak} />
          <div className={styles.arrowLine} />
        </div>
      )}
      <Row className={styles.itemWrapper}>
        <div className={styles.avatarColumn}>
          <AvatarLoadManager
            name={historyItem?.Emp_Name_e}
            onlyIcon={Profile}
          />
          <div className={styles.itemInfo}>
            <span className={styles.itemInfoName}>
              {historyItem?.ActionStatus_Description_English}
            </span>
            <span className={styles.itemPosition}>
              {historyItem.Action_Description_English}
            </span>
          </div>
        </div>

        <div className={styles.dateColumn}>
          <div className={styles.itemInfo}>
            <span className={styles.itemApprovalTime}>
              {historyItem?.ActionDatetime &&
                format(
                  new Date(historyItem?.ActionDatetime),
                  DEFAULT_TIME_FORMAT,
                )}
            </span>
            <span className={styles.itemApprovalDate}>
              {historyItem?.ActionDatetime &&
                format(
                  new Date(historyItem?.ActionDatetime),
                  DEFAULT_DATE_FORMAT,
                )}
            </span>
          </div>
        </div>

        <div className={styles.statusColumn}>{historyItem?.Remarks}</div>
      </Row>
    </>
  );
};
